import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useMediaQuery } from "@mui/material";
import { tabsClasses } from "@mui/material/Tabs";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import Certificate from "./Certificate";
import CustomCertificate from "./Custom/CertificatePrint";
const StudentReport = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [value, setValue] = React.useState("certificate");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <TabContext value={value}>
        <TabsWrapper sx={{ width: isMobile ? "100%" : "auto" }}>
          <TabList
            variant="scrollable"
            scrollButtons={isMobile}
            allowScrollButtonsMobile
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
              width: isMobile ? "85vw" : "auto",
            }}
            aria-label="ekalsutra erp tab"
            onChange={handleChange}
          >
            <Tab wrapped label="Certificate" value="certificate" />
            <Tab wrapped label="Custom Certificate" value="custom" />
          </TabList>
        </TabsWrapper>
        <TabPanel value="certificate" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 1 }}>
            <Certificate />
          </Box>
        </TabPanel>
        <TabPanel value="custom" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 1 }}>
            <CustomCertificate />
          </Box>
        </TabPanel>
      </TabContext>
    </>
  );
};

export default StudentReport;
